module.exports = __webpack_public_path__ + "static/media/policy_settings_approvals_workflow_add.06202e3f.svg";